
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"currentColor","stroke":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.125 4.125a3.375 3.375 0 1 0 6.75 0 3.375 3.375 0 1 0-6.75 0Zm7.428 6.375a6.028 6.028 0 0 0-8.106 0","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M14.875 4.236A6.752 6.752 0 0 1 13 4.5a6.723 6.723 0 0 1-4.568-1.781m6.693 13.406a3.375 3.375 0 1 0 6.75 0 3.375 3.375 0 1 0-6.75 0Zm8.125 7.125a6.026 6.026 0 0 0-9.5 0","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M21.875 16.236a6.76 6.76 0 0 1-6.443-1.517M2.125 16.125a3.375 3.375 0 1 0 6.75 0 3.375 3.375 0 1 0-6.75 0Zm8.124 7.125a6.026 6.026 0 0 0-9.5 0","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M8.875 16.236a6.76 6.76 0 0 1-6.443-1.517","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}})])
          )
        }
      }
    